// Copyright (c) 2016 Deere & Company

import actions from '../../action-list';
import {getDefaultState as getClaimDefaultState} from '../state';

const resetIsCopied = () => getClaimDefaultState().isCopied;

const setIsCopied = (state, action) => action.isCopied;

export default (state = getClaimDefaultState().isCopied, action) => {

    const actionTypes = {
        [actions.UPDATE_CLAIM_PIP_IS_COPIED]: setIsCopied,
        [actions.COPY_CLAIM_PIP]: setIsCopied,
        [actions.ADD_CLAIM_PIP_ADDITIONAL_REPAIR]: resetIsCopied,
        [actions.RESET_CLAIM_PIP]: resetIsCopied
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/pip/reducers/is-copied.js